import { newService } from './service';

/**
 *
 *
 * LOAD APP
 *
 *
 */

if (process.env.NODE_ENV === 'development') {
  /**
   * Only for local development
   * We need to simulate HOST functionality and run our service
   */
  (async () => {
    const { initMockShell } = await import('./services/MockShell');
    // Mock HOST
    initMockShell(newService.name, {
      'base-url': '/casino/instant-games',
      'render-container': '#instant-games',
      language: 'en',
      brand: process.env.REACT_APP_BRAND || 'COM',
      channel: 'MOBILE_WEB',
      'cross-domain-click-stream-id': '',
      'proxy-prefix': `/service-discovery/service/${newService.name}`,
      'user-token': process.env.REACT_APP_TOKEN || '',
      'ams:segments': [],
      platform: 'natasha',
      'user-data': {
        currency: { id: 3, name: 'USD', isRestricted: false, isCupis: false },
        balances: { total: 1000 },
      },
    });

    window.newService = newService;

    // aba-mock-host is only for development.
    // It should be required dynamically to prevent useless css files import in production build
    require('aba-mock-host').render({
      shellId: 'shell',
      rootId: 'instant-games',
      withHeaderProjectPicker: false,
    });

    newService.start();
  })();
} else {
  newService.start();
}
